// @flow
import React from "react"
import classnames from "classnames"

type Props = {
  checked?: boolean,
  onChange?: string => void,
  value?: string,
  disabled?: boolean,
}

const RadioButtonsRadio = ({ checked, onChange, value, disabled }: Props) => (
  <div className={classnames("RadioButtonsRadio", { _checked: checked })}>
    <div className={classnames("RadioButtonsRadio-outer", { _disabled: disabled })}>
      <div className="RadioButtonsRadio-inner" />
      <input type="radio" onChange={onChange} checked={checked} value={value} />
    </div>
  </div>
)

export default RadioButtonsRadio
